import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { loadCss } from "helpers/function";
import HeaderTablePage from "views/components/HeaderTablePage";
import InfirmationTable from "views/components/InfirmationTable";
import { useQuotaData } from "hooks/configs/quota-delais/useQuotaData";
import { useQuotaForm } from "hooks/configs/quota-delais/useQuotaForm";
import { PermissionGuard } from "components/configs/quota-delais/PermissionGuard";
import { PageHeader } from "components/configs/quota-delais/PageHeader";
import { QuotaForm } from "components/configs/quota-delais/QuotaForm";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const ConfigQuotaDelais = (props) => {
  const { t, ready } = useTranslation();
  const [isQuotaUsed, setIsQuotaUsed] = useState(true);

  useEffect(() => {
    document.title =
      "Satis configuration - " + (ready ? t("Quota de délais") : "");
  }, [ready, t]);

  const { quotaData, isLoading, error, endpoint } = useQuotaData(
    props.plan,
    props.userPermissions
  );

  const quotaForm = useQuotaForm(quotaData || {}, endpoint, props.userPermissions, t);

  const {
    quotas = [],
    quotasErrors = [],
    isSubmitting = false,
    updateQuota = () => {},
    handleSave = () => {},
  } = quotaForm;

  const handleCheckboxChange = () => {
    setIsQuotaUsed(!isQuotaUsed);
  };

  const handleInputChange = (field, value) => {
    updateQuota(field, value);
  };

  if (!ready) return null;

  return (
    <div
      className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <PageHeader t={t} />

      <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
        <PermissionGuard userPermissions={props.userPermissions} t={t}>
          <InfirmationTable
            information={t("Configuration du quota des délais")}
          />

          <div className="kt-portlet">
            <HeaderTablePage title={t("Quota des délais")} />

            <div className="kt-portlet__body">
              <div
                id="kt_table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="row">
                  <label className="kt-checkbox">
                    <input
                      id="is_quota"
                      type="checkbox"
                      checked={isQuotaUsed}
                      onChange={handleCheckboxChange}
                    />
                    {t(
                      "Voulez-vous faire la répartition des délais suivant les étapes du processus"
                    )}{" "}
                    ?
                    <span />
                  </label>
                </div>

                {isQuotaUsed && !isLoading && (
                  <QuotaForm
                    quotas={quotas}
                    quotasErrors={quotasErrors}
                    onInputChange={handleInputChange}
                    onSave={handleSave}
                    isSubmitting={isSubmitting}
                    t={t}
                  />
                )}

                {isLoading && (
                  <div className="text-center p-4">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                )}

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {t("Erreur lors du chargement des données")}
                  </div>
                )}
              </div>
            </div>
          </div>
        </PermissionGuard>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
  plan: state.plan.plan,
});

export default connect(mapStateToProps)(ConfigQuotaDelais);
